/*Sidebar*/
/*eslint-disable */
import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias_white.svg'
import i_beneficios from './../UI/icons/Sidebar/Beneficios.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Beneficios_white.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades_white.svg'
import i_etapas from './../UI/icons/Sidebar/Etapas.svg'
import i_etapas2 from './../UI/icons/Sidebar/Etapas_white.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_lobby from './../UI/icons/Amenities/Porteria.svg'
import i_lobby2 from './../UI/icons/Amenities/Porteria White.svg'
import i_gym from './../UI/icons/Amenities/Gym.svg'
import i_gym2 from './../UI/icons/Amenities/Gym_white.svg'
import i_bbq from './../UI/icons/Amenities/BBQ.svg'
import i_bbq2 from './../UI/icons/Amenities/BBQ_white.svg'
import i_salonSocial from './../UI/icons/Amenities/SalonSocial.svg'
import i_salonSocial2 from './../UI/icons/Amenities/SalonSocial_White.svg'
import i_terraza from './../UI/icons/Amenities/Terraza.svg'
import i_terraza2 from './../UI/icons/Amenities/Terraza_White.svg'
import i_salonJuegos from './../UI/icons/Amenities/Salon_Ninos.svg'
import i_salonJuegos2 from './../UI/icons/Amenities/Salon_Ninos_White.svg'
import i_cancha from './../UI/icons/Amenities/Cancha.svg'
import i_cancha2 from './../UI/icons/Amenities/Cancha_White.svg'
import i_piscina from './../UI/icons/Amenities/Piscina.svg'
import i_piscina2 from './../UI/icons/Amenities/Piscina_White.svg'
import i_parque from './../UI/icons/Amenities/Juegos infantiles.svg'
import i_parque2 from './../UI/icons/Amenities/Juegos infantiles_White.svg'
import i_petPark from './../UI/icons/Amenities/Mascotas.svg'
import i_petPark2 from './../UI/icons/Amenities/Mascotas White.svg'
import i_Senderos from './../UI/icons/Amenities/Senderos.svg'
import i_Senderos2 from './../UI/icons/Amenities/Senderos_White.svg'
/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'

import i_salud2 from './../UI/icons/POI/Salud_White.svg'
import i_comercio2 from './../UI/icons/POI/Comercio_White.svg'
import i_colegios2 from './../UI/icons/POI/Educacion_White.svg'
import i_parques2 from './../UI/icons/POI/Parques_White.svg'


export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Lobby': i_lobby,
    'Lobby2': i_lobby2,
    'Gimnasio': i_gym,
    'Gimnasio2': i_gym2,
    'Zona BBQ': i_bbq,
    'Zona BBQ2': i_bbq2,
    'Salón Social': i_salonSocial,
    'Salón Social2': i_salonSocial2,
    'Terraza con Mirador': i_terraza,
    'Terraza con Mirador2': i_terraza2,
    'Salón de Juegos': i_salonJuegos,
    'Salón de Juegos2': i_salonJuegos2,
    'Cancha Recreativas': i_cancha,
    'Cancha Recreativas2': i_cancha2,
    'Piscina Tipo Playa': i_piscina,
    'Piscina Tipo Playa2': i_piscina2,
    'Parque Infantil': i_parque,
    'Parque Infantil2': i_parque2,
    'Parque Mascotas': i_petPark,
    'Parque Mascotas2': i_petPark2,
    'Senderos de Trote': i_Senderos,
    'Senderos de Trote2': i_Senderos2,
    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Educación": i_colegios,
    "Educación2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
}